import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../../assets/stylesheets/application.tailwind.css'

let root = null

createInertiaApp({
  resolve: name => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    const page = pages[`../pages/${name}.jsx`]
    
    // Ensure default layout is applied if not specified, 
    // BUT only if we were doing automatic layouts. 
    // Here we are manually wrapping in UserLayout, so we just return the page.
    return page
  },
  setup({ el, App, props }) {
    // Ensure the root element has full height
    el.classList.add('h-full', 'w-full')
    
    // CRITICAL: Only create root once to prevent duplicate rendering
    // Reuse the same root instance for all subsequent renders
    if (!root) {
      root = createRoot(el)
    }
    
    root.render(<App {...props} />)
  },
})
